import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useDesktopNavbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '250px',
      paddingLeft: theme.spacing(),
      paddingRight: theme.spacing(),
      minWidth: '250px',
      minHeight: '100vh',
      borderRight: theme.customPalette.red,
      display: 'flex',
      flexDirection: 'column',
      borderRightColor: theme.customPalette.red,
      borderRightStyle: 'solid',
      borderRightWidth: 1,
    },
    menuList: {
      listStyleType: 'none',
      padding: '0px',
      color: theme.customPalette.white,
    },
    listItem: {
      display: 'flex',
      alignItems: 'center',
    },
    separator: {
      borderBottom: `1px solid ${theme.customPalette.red}`,
      width: '200px',
      margin: `${theme.spacing()} 0 ${theme.spacing()} ${theme.spacing()}`,
      [theme.breakpoints.down('sm')]: {
        width: '345px',
      },
    },
  })
);
